import React from "react";
import {ATag} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {InView} from "react-intersection-observer";
// eslint-disable-next-line no-unused-vars
import PlusMore from "../Components/PlusMore";
import css from "./TagList.module.scss";

/**
 * Renders a list of Tags for an entity.
 * Tags will render in a single row only, if there are remaining hidden items,
 * a `+N` button will show.
 *
 * @todo Currently no data available via API, change input prop name to match
 * endpoint property name for convenience if needed.
 */
const TagList = ({tags, className}) => {
  //TODO mark back in after RSA - tracked here: https://github.com/advthreat/incident-manager/issues/647
  // const [remaining, setRemaining] = useState(tags?.length - 1);

  return tags?.length ? (
    <div className={classNames("mt-1", className)}>
      {/* //TODO mark back in after RSA - tracked here: https://github.com/advthreat/incident-manager/issues/647 /*}
      {/* <div className="overflow-hidden"> */}
      <div role="list" className={classNames(css.tagList)}>
        {tags.map((tag, i) => (
          <InView
            key={i}
            threshold={0}
            onChange={
              //TODO mark back in after RSA - tracked here: https://github.com/advthreat/incident-manager/issues/647
              (isVisible) => {}
              // setRemaining(isVisible ? remaining - 1 : remaining + 1)
            }>
            {({ref}) => (
              <div role="listitem" className={css.tagListItem}>
                <ATag ref={ref} className={classNames(css.tag, "mr-1 mb-1")}>
                  <span className="text-truncate">{tag}</span>
                </ATag>
              </div>
            )}
          </InView>
        ))}
      </div>
      {/* </div> */}
      {/* //TODO mark back in after RSA - tracked here: https://github.com/advthreat/incident-manager/issues/647 /*}
      {/* {remaining > 0 && (
        <PlusMore className="ml-1 mt-1" remaining={remaining} />
      )} */}
    </div>
  ) : null;
};

TagList.propTypes = {};

export default TagList;
